module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","Save":"Save","Cancel":"Cancel","new_item":"Add","show_deleted":"Show deleted"},"de":{"search":"Suche","Save":"Speichern","Cancel":"Stornieren","new_item":"Hinzufügen","show_deleted":"Sendung gelöscht"}}')
  delete Component.options._Ctor
}
